export default {
    // Navbar
    nav: {
      home: '首页',
      about: '关于我',
      strategies: '策略',
      performance: '业绩',
      portfolioBuilder: '投资组合构建器',
      insights: '分析洞察',
      reports: '周报',
      terminal: 'Quant Lab',
      contact: '联系方式',
      institutional: '机构投资者',
    },
    
    // Home Page
    home: {
      ticker: {
        subtitle: '量化交易 · 系统性策略',
      },
      hero: {
        title: 'HMA Quant Strategies',
        description: '量化分析师，开发算法策略，年化收益超过',
        cagr: '40% CAGR',
        and: '和',
        sharpe: 'Sharpe > 1.5',
        additionalPrefix: '拥有',
        drawdowns: '回撤',
        additionalMiddle: '低于',
        drawdownValue: '15%',
        additionalAnd: '以及超过',
        years: '20年',
        ctaPrimary: '探索策略',
        ctaSecondary: '关于我',
      },
      featured: {
        label: '精选策略',
        cta: '探索ARES →',
      },
      tech: {
        label: '量化基础设施',
        title: '数学与',
        titleAccent: '计算工具',
        footer: '基于机构级数据的严格回测验证的系统性策略',
      },
      timeline: {
        label: '职业历程',
        title: '职业',
        titleAccent: '里程碑',
        milestones: [
          {
            title: '物理学学位',
            description: '完成大学学位，专攻理论物理和应用数学。',
          },
          {
            title: '量化金融硕士',
            description: '数学建模、量化分析和算法策略开发的专业培训。',
          },
          {
            title: '对冲基金+算法策略',
            description: '在西班牙对冲基金开始工作。开发和实施基于股息的算法策略。',
          },
          {
            title: 'London broker (FTSE 100)',
            description: '加入FTSE 100成分股broker经纪公司，从事量化开发工作。',
          },
          {
            title: '生产中的策略',
            description: '多个算法策略投入生产，使用真实资本。系统性交易组合正常运营。',
          },
        ],
      },
      features: {
        title: '为什么用量化策略投资？',
        subtitle: '基于数据的算法系统、严格的回测和机构风险管理',
        items: [
          {
            title: '动量与择时',
            description: '在15年历史数据中验证的动量和市场择时策略，CAGR达+40%'
          },
          {
            title: '贝叶斯模型',
            description: '使用隐马尔可夫模型进行市场制度检测和动态适应'
          },
          {
            title: '市场中性',
            description: '通过Beta/R²相关分析的多空策略，降低方向性风险'
          },
          {
            title: '自动化系统',
            description: '可在自营公司和机构经纪商中完全自动化的日内交易'
          },
          {
            title: '多资产',
            description: '美国股票、指数、加密货币、波动率(VIX) - 真正的多元化'
          },
          {
            title: '机构履历',
            description: '在对冲基金和FTSE 100经纪商管理高达2亿美元投资组合的经验'
          }
        ]
      },
      cta: {
        title: '准备好开始了吗？',
        subtitle: '在Darwinex、eToro和Wikifolio上探索我的策略，或在Substack上阅读我的量化分析',
        ctaPrimary: '投资渠道',
        ctaSecondary: '联系方式'
      }
    },

    // About Me Page
    about: {
      title: '量化分析师',
      intro1: '量化分析师，拥有',
      physics: '物理学(理学学士)',
      and: '和',
      finance: '量化金融(理学硕士)',
      intro2: '目前在一家伦敦知名经纪商 (FTSE 100)工作，开发统计模型和系统性交易策略。',
      intro2b: '目前为CFA (特许金融分析师)候选人——投资行业最负盛名且全球公认的认证。',
      intro3: '曾在西班牙对冲基金管理高达',
      amount: '2亿美元的投资组合',
      intro4: '，并在大宗商品基金从事能源衍生品定价和风险管理，结合数学严谨性、机器学习和深厚的市场知识，构建稳健且可复制的算法。',
      trackRecordTitle: '业绩记录',
      trackRecordTitle2: '构建在任何市场制度下产生一致风险调整后收益的量化策略。',
      trackRecordParagraph1: '专业经验包括优化系统性策略，将风险调整后收益从年化12%提高到23%，并为涵盖超过2亿欧元管理资产的投资组合管理和研究做出贡献。',
      trackRecordParagraph2: '设计并测试了超过40个股票、衍生品和固定收益证券的量化模型。每个策略都在数十年的历史数据上进行了测试，并通过实盘模拟交易和真实市场条件进行了验证。',
      trackRecordParagraph3: '单独来看，每个策略在其资产类别内寻求受控风险。组合成多元化投资组合后，实现夏普比率超过1.5，最大回撤控制在-15%以下，与传统基准的相关性接近零。',
      trackRecordDisclaimer: '结果基于回测和实盘模拟交易。过往业绩不保证未来收益。除非明确指定为实盘，否则所有收益均为假设性的。',
      trackRecordParagraph4: '从基于动量的股票投资组合到统计套利市场中性策略，从波动率捕获到宏观量化，无论您是寻求系统性曝露的零售投资者还是寻求非相关收益流的机构，我们构建适合您风险配置和目标的策略。',

      trackRecordDescription: '构建在任何市场制度下产生一致风险调整后收益的量化策略。我们的业绩记录通过数字说话：十二个独立策略，旨在最小化回撤同时最大化阿尔法，每个策略都经过数十年历史数据测试并在实盘模拟交易中验证。单独来看，每个策略在其资产类别内寻求受控风险。组合成多元化投资组合后，实现夏普比率超过1.5，最大回撤控制在-15%以下，与传统基准的相关性接近零。从股票动量组合到统计套利市场中性策略，从波动率捕获到宏观量化，无论您是寻求系统性曝露的个人投资者还是寻求非相关收益来源的机构，我们构建适合您风险配置和目标的策略。',
      expertiseTitle: '专业技能',
      expertise: [
        '动量和择时策略的+40% CAGR',
        '使用隐马尔可夫模型进行制度检测的贝叶斯模型',
        '具有Beta/R²相关分析的市场中性策略',
        '可在自营公司完全自动化的日内系统',
        '多资产：美国股票、指数、加密货币、波动率(VIX)',
        '机构业绩记录：管理高达2亿美元的投资组合',
      ],
      toolsTitle: '数学与计算工具',
      toolsSubtitle: '我用于量化研究和系统性交易的技术和框架',
      clickToFlip: '点击查看更多',
      clickToFlipBack: '点击返回',
      clickForDetails: '点击了解详情 →',
      clickToClose: '点击关闭 ←',
      tools: {
        python: {
          name: 'Python',
          description: '回测、统计分析和策略开发的主要语言'
        },
        numpy: {
          name: 'NumPy',
          description: '数值计算和数组操作的基础包'
        },
        pandas: {
          name: 'Pandas',
          description: '时间序列的高性能数据处理和分析'
        },
        scikit: {
          name: 'Scikit-learn',
          description: '用于模式识别和预测分析的机器学习模型'
        },
        tensorflow: {
          name: 'TensorFlow',
          description: '用于建模复杂市场行为的深度学习框架'
        },
        pytorch: {
          name: 'PyTorch',
          description: '用于高级深度学习研究的动态神经网络'
        },
        git: {
          name: 'Git',
          description: '代码管理和协作开发的版本控制'
        },
        vscode: {
          name: 'VS Code',
          description: '高效代码开发和调试的专业IDE'
        },
        jupyter: {
          name: 'Jupyter',
          description: '用于研究、可视化和策略原型的交互式笔记本'
        },
        quantlib: {
          name: 'QuantLib',
          description: '衍生品定价和风险管理的量化金融库'
        },
        backtrader: {
          name: 'Backtrader',
          description: '策略回测和实盘交易的Python框架'
        },
        postgresql: {
          name: 'PostgreSQL',
          description: '结构化金融数据存储的强大关系数据库'
        },
        mongodb: {
          name: 'MongoDB',
          description: '非结构化市场数据灵活存储的NoSQL数据库'
        },
        docker: {
          name: 'Docker',
          description: '不同环境中一致部署的容器化'
        },
        aws: {
          name: 'AWS',
          description: '可扩展计算和数据处理的云基础设施'
        },
        mathematics: {
          name: '数学',
          description: '量化金融基础的高级数学概念'
        },
        statistics: {
          name: '统计学',
          description: '假设检验和推断的统计方法'
        },
        linearalgebra: {
          name: '线性代数',
          description: '投资组合优化和因子模型的矩阵运算'
        },
        timeseries: {
          name: '时间序列',
          description: '预测和趋势检测的时间数据分析'
        },
        calculus: {
          name: '微积分',
          description: '期权定价和优化的导数和积分'
        },
        probability: {
          name: '概率论',
          description: '风险评估和决策的概率模型'
        },
        optimization: {
          name: '优化',
          description: '投资组合配置和策略调整的数学优化'
        },
        bayesian: {
          name: '贝叶斯',
          description: '制度检测和参数估计的贝叶斯推断'
        },
        stochasticcalculus: {
          name: '随机微积分',
          description: '价格动态和衍生品建模的随机过程'
        },
        montecarlo: {
          name: '蒙特卡洛',
          description: '风险分析和场景测试的模拟方法'
        }
      },
      ctaTitle: '准备以不同方式投资了吗？',
      ctaSubtitle: '探索我的量化策略或与我联系。',
      ctaStrategies: '查看策略',
      ctaContact: '联系方式',
      milestones: [
        {
          title: '物理学学位',
          description: '完成大学学位，专攻理论物理和应用数学。',
          shortDetail: '微积分、线性代数、量子力学、统计力学、电磁学、相对论和Python/Fortran/C科学编程的基础。'
        },
        {
          title: '量化金融硕士',
          description: '数学建模、量化分析和算法策略开发的专业培训。',
          shortDetail: 'Python编程、计量经济学、衍生品、投资组合管理、机器学习、深度学习、NLP、强化学习、AWS部署和量子计算。'
        },
        {
          title: '对冲基金',
          description: '加入西班牙对冲基金，为顶级机构客户工作。',
          shortDetail: '量化分析师，为Edmond de Rothschild、Millennium和美国公司管理投资组合。数据驱动研究、流程优化和量化研究。'
        },
        {
          title: '能源交易',
          description: '为荷兰公司在全球能源市场进行交易和风险管理。',
          shortDetail: '欧洲互联交易机会。Repsol、Glencore、TMS的优化项目。Reuters Eikon、ETRM开发、CPLEX/Gurobi求解器、蒙特卡洛定价。'
        },
        {
          title: 'IG Group (FTSE 100)',
          description: 'FTSE 100经纪商的量化分析师，开发ML模型用于交易优化和风险管理。',
          shortDetail: '作为做市商的XGBoost/Random Forest风险管理模型。统计研究、PnL管道、GCP/BigQuery/Streamlit仪表板。为伦敦和墨尔本团队报告。'
        },
        {
          title: '生产中的策略',
          description: '开发和运营多资产类别真实资本的专有算法策略。',
          shortDetail: '市场中性、动量、配对交易、基于ML的交易、外汇、加密货币、波动率策略。从假设到实盘执行的完整管道。详见Strategies部分。'
        }
      ],
      eventsTitle: '活动',
      eventsAttendTitle: '我参加 / 推荐的活动',
      eventsOrganizeTitle: '我组织 / 演讲的活动',
      eventAttending: '参加者',
      eventOrganizer: '组织者',
      eventQuantConference: '量化金融会议',
      eventQuantConferenceLocation: '伦敦，2026年6月',
      eventQuantConferenceDesc: '量化研究者和从业者的领先活动。专注于系统性交易和风险管理。',
      eventQuantMeetup: '量化金融聚会',
      eventQuantMeetupLocation: '马德里，2025',
      eventQuantMeetupDesc: '为量化研究者和从业者组织的社区活动。专注于分享系统性交易策略和社交网络。',
      eventsComingSoon: '更多活动即将推出...',
      podcastsTitle: '播客 · 即将上线',
      podcastsDescription: '与量化金融领域的从业者、研究者和创建者进行的系列对话。目前正在筹划中。如希望在上线时收到通知，请通过联系页面订阅。',
      disclaimer: '本网站提供的信息仅供教育和信息用途。不构成财务、投资或交易建议。过去的表现不保证未来的结果。在做出任何投资决策之前，请务必咨询持牌财务顾问。',
    },

    // Strategies Page
    strategies: {
      title: '量化策略',
      subtitle: '经过严格回测的机构级算法系统',
      compareTitle: '绩效对比',
      compareSubtitle: '对比所有策略的关键指标',
      riskLevel: '风险等级',
      moderate: '中等',
      high: '高',
      veryHigh: '非常高',
      viewStrategy: '查看策略',
      equityCurve: '权益曲线',
      drawdownAnalysis: '回撤分析',
      maxDrawdownComparative: '最大回撤对比',
      comparativeMetrics: '对比指标',
      correlation: '相关性',
      correlationWithBenchmarks: '与基准的相关性',
      downloadBrochure: '📄 下载手册',
      annualReturns: '年度收益',
      historicalDataDisclaimer: '* 历史数据期间 {start} - {end}。过往业绩不保证未来收益。',
      strategyNames: {
        tyr: 'TYR策略',
        ares: 'ARES策略',
        ascalafo: 'ASCÁLAFO策略',
        deimos: 'DEIMOS策略',
        fobos: 'FOBOS策略',
        bes: 'BES策略',
        janus: 'JANUS策略',
        hraesvelgr: 'HRÆSVELGR策略',
      },
      metrics: {
        cagr: 'CAGR',
        sharpe: 'Sharpe',
        maxDD: '最大回撤',
        volatility: '波动率',
      },
      strategyDescriptions: {
        tyr: '双动量轮动',
        ares: '市场择时',
        ascalafo: '双层',
        deimos: '市场择时+风险',
        fobos: '双层+风险',
        bes: '趋势跟踪',
        janus: '行业轮动',
        hraesvelgr: '进取全天候',
      },
      strategyFullDescriptions: {
        tyr: 'TYR以北欧秩序、正义和保护之神命名，是一个适合以纪律和韧性驾驭市场的策略的恰当象征。TYR是受Ray Dalio全天候哲学原则启发的双动量轮动量化策略。',
        ares: 'ARES是专有的市场择时量化策略。在近20年的历史数据(2006-2026)上开发和验证，已通过现代市场最大压力事件证明了稳健性：2008年金融危机、2020年大流行、2022年激进加息周期和2024-2025年极端波动。',
        ascalafo: '美国市场双层专有市场择时策略。两个独立的信号系统结合以实现最大入场/出场精度。100%系统化，二元受控暴露。',
        deimos: 'DEIMOS是具有更高受控风险的专有市场择时量化策略。在近20年的历史数据(2006-2026)上开发和验证，已通过现代市场最大压力事件证明了稳健性。具有比ARES更激进的风险配置，旨在在牛市中最大化收益同时保持系统纪律。',
        fobos: '美国市场双层专有市场择时策略，具有高风险/回报配置。两个独立的信号系统结合以实现最大入场/出场精度。100%系统化，二元受控暴露，优化杠杆适合风险承受能力更高的投资者。',
        bes: 'BES is a systematic trend-following strategy focused on medium-term growth. It holds names that are technically outrunning the broad market, combining relative strength, momentum and trend stability to filter noise.',
        janus: 'JANUS是一个每周完全再平衡的量化股票选择系统，以多空市场中性模式运作。其名称唤起了罗马双面神——正是同时持有多头和空头头寸的双重性。',
        hraesvelgr: 'HRÆSVELGR is TYR’s more aggressive twin in the All Weather family. Same regime discipline, more appetite for growth, and a faster shift to defence when momentum fades.',
      },
    },

    // Portfolio Builder Page
    portfolioBuilder: {
      title: '投资组合构建器',
      subtitle: '通过组合多个量化策略构建您的个性化投资组合',
      riskWarning: {
        title: '⚠ 风险警告',
        content: '量化策略涉及资本损失风险。显示的历史表现基于回测和模拟——不保证未来收益。这是一个教育工具，不构成投资建议、推荐或买卖证券的邀约。',
      },
      hero: {
        heading1: '构建您的',
        heading2: '理想投资组合',
        description: '探索我们策略的投资组合组合。该工具允许您模拟配置、分析历史指标，并了解不同策略权重如何影响风险调整后收益。这是一个教育工具——而非个性化投资建议。',
        disclaimer: '仅供教育用途。基于历史数据的模拟结果。不构成投资建议。',
      },
      tabs: {
        build: '构建投资组合',
        models: '模型投资组合',
        saved: '已保存的投资组合',
      },
      buildSection: {
        selectTitle: '选择策略',
        selectSubtitle: '选择至少2个策略进行组合',
        weightsTitle: '分配权重',
        weightsSubtitle: '总数必须为100%',
        totalWeight: '总权重',
        distributeEqually: '平均分配',
        optimize: '自动优化(Sharpe)',
        generate: '生成投资组合',
        validationError: '选择至少2个策略并确保权重总和为100%',
        optimizeSuccess: '投资组合已优化，预期Sharpe：',
        optimizeError: '优化投资组合时出错',
      },
      modelsSection: {
        title: '模型投资组合',
        subtitle: '针对不同风险配置预配置的投资组合',
        usePortfolio: '使用此投资组合',
        questionnaire: '填写问卷',
      },
      savedSection: {
        title: '已保存的投资组合',
        subtitle: '访问您之前保存的投资组合配置',
        noSaved: '还没有保存的投资组合',
        load: '加载',
        delete: '删除',
      },
      results: {
        title: '投资组合结果',
        composition: '投资组合组成',
        metrics: '关键指标',
        performance: '历史表现',
        returns: '月度收益',
        exportPDF: '下载投资组合报告',
        save: '保存投资组合',
        saveSuccess: '投资组合保存成功！',
        saveError: '保存投资组合时出错',
        period: '期间',
        strategies: '策略',
        tabs: {
          equity: '资本曲线',
          drawdown: '回撤',
          annual: '年度收益',
        },
      },
      modelPortfolios: {
        conservative: {
          name: '保守型',
          description: '低波动性，强调资本保值',
          riskLevel: '低',
        },
        balanced: {
          name: '平衡型',
          description: '增长与风险管理之间的平衡',
          riskLevel: '中等',
        },
        growth: {
          name: '增长型',
          description: '专注于更高收益，波动性更大',
          riskLevel: '高',
        },
        aggressive: {
          name: '进取型',
          description: '最大化收益，高波动性',
          riskLevel: '非常高',
        },
      },
      questionnaire: {
        title: '风险承受能力问卷',
        subtitle: '回答这些问题以找到适合您的投资组合',
        questions: [
          {
            question: '您的投资时间范围是多长？',
            options: [
              '少于1年',
              '1-3年',
              '3-5年',
              '超过5年'
            ]
          },
          {
            question: '如果您的投资组合损失20%，您会如何反应？',
            options: [
              '立即全部卖出',
              '卖出部分投资组合',
              '保持投资组合',
              '增加投资'
            ]
          },
          {
            question: '您的主要目标是什么？',
            options: [
              '保值资本',
              '稳定收入',
              '适度增长',
              '最大增长'
            ]
          }
        ],
        submit: '获取建议',
      },
      common: {
        selectStrategies: '选择策略',
        selectedStrategies: '已选策略',
        allocation: '配置',
        projectedMetrics: '预计指标',
        initialInvestment: '初始投资',
        monthlyContribution: '月度投入',
        timeHorizon: '时间范围',
        years: '年',
        projectedValue: '预计价值',
        totalInvested: '总投资',
        totalReturns: '总收益',
        riskWarning: '⚠️ 风险警告',
        riskWarningText: '这是一个教育工具。预计收益基于历史表现，不保证未来结果。交易涉及风险。请咨询财务顾问。',
        resetPortfolio: '重置投资组合',
        chart: {
          portfolioGrowth: '投资组合增长',
          invested: '已投资',
          projected: '预计',
        },
        summary: {
          summary: '摘要：',
          summaryText1: '初始投资',
          summaryText2: '每月投入',
          summaryText3: '，总共投资',
          summaryText4: '在',
          summaryText5: '中，获得最终价值',
          years: '年',
        },
      },
    },

    // Insights Page
    insights: {
      title: '分析洞察',
      subtitle: '策略、分析和智能投资资源',
      substackSection: {
        title: 'SUBSTACK最新文章',
        loading: '加载最新文章...',
        error: '无法加载文章。请稍后重试。',
        errorWithLink: 'Substack 上的最新文章：',
      },
      newsletterTitle: 'HMA量化通讯',
      visitSubstack: '访问我的Substack',
      weeklyNewsletter: '周报',
      analysisAndNewsletter: '洞察与通讯',
      subscribe: '订阅',
      newsletterIntro: '我在Substack上分享量化分析、投资论点和S&P500期权图的每日笔记',
      newsletterDescription: '直接通过电子邮件接收深度技术分析、量化投资论点和S&P500期权每日图表。为寻求信息优势的交易者提供独家内容。',
      newsletterBadge1: '量化分析',
      newsletterBadge2: '期权图',
      newsletterBadge3: '投资论点',
      whereToInvestTitle: '投资渠道',
      whereToInvestSubtitle: '您可以在以下受监管平台关注我的量化策略。每个策略都有自己的风险-收益特征，可用于跟单交易或直接投资。',
      darwinex: {
        title: 'Darwinex',
        description: 'FCA监管的算法策略跟单交易平台',
        strategies: '策略',
      },
      etoro: {
        title: 'eToro',
        description: '全球数百万用户的社交交易平台',
        profile: '我的资料',
      },
      wikifolio: {
        title: 'Wikifolio',
        description: '可投资策略证书的欧洲平台',
        profile: '我的资料',
      },
      resourcesTitle: '教育资源',
      resourcesSubtitle: '改善您量化投资的文章、工具和指南',
      comingSoon: '即将推出',
    },

    // Weekly Reports Page  
    weeklyReports: {
      title: '每周量化报告',
      subtitle: '订阅每个策略的深度量化研究。每份报告深入分析数学框架、每周模型开发、投资组合变动以及每个策略演变背后的量化推理。',
      subscriptionOptions: '订阅选项',
      pricePerMonth: '€{price}/月',
      subscribe: '订阅',
      manage: '管理订阅',
      alreadySubscribed: '已订阅',
      signInToSubscribe: '登录以订阅',
      statusActive: '有效',
      statusCancelling: '将于 {date} 取消',
      statusExpired: '已过期',
      billingMonthly: '按月计费',
      cancelAnytime: '随时取消',
      availableOnBrokers: '各大主流券商均可交易',
      assetsLabel: '资产:',
      whatYouGet: '您将获得:',
      subscribers: '{count} 订阅者',
      loading: '加载中...',
      errorLoading: '加载失败',
      subscribeTo: '订阅',
      subscribed: '已订阅',
      cancelsOn: '取消日期',
      completeBundle: '完整套餐',
      completeBundleDesc: '所有策略 + 市场报告 + 量化宏观观点',
      bestValue: '最佳价值',
      perMonth: '/月',
      perYear: '/年',
      planMonthly: '月付',
      planAnnual: '年付',
      twoMonthsFree: '赠2个月',
      equivMonthly: '约合 €{price}/月',
      savingsText: '(单独€479,92 — 节省€184,93 + 宏观内容)',
      savingsTextAnnual: '(单独€4.799,92 — 节省€1.849,93 + 宏观内容)',
      getFullAccess: '获取完全访问权限',
      includes: '包含：',
      bundleIncludes: {
        strategies: '22个策略(TYR、HRÆSVELGR、ARES、JANUS、BES、FOBOS、DEIMOS、ASCÁLAFO、EOS、ARTEMIS、HELIOS、HYPERION、HORAI、THEIA、ASTRAEUS、PHAETHON、HEMERA、SELENE、ASTERIA、AETHER、HEIMDALL、METIS)',
        weeklyReports: '完整分析的周报',
        macroInsights: '量化宏观经济观点',
        historicalAccess: '完整历史档案访问',
        transparentSignals: '透明推理的信号',
      },
      exclusiveAccess: '独家访问',
      exclusiveAccessDesc: '详细的周报，包含交易信号、市场分析和量化观点',
      loginRequired: '需要登录以访问报告',
      noSubscription: '您没有活跃订阅',
      subscribeNow: '立即订阅',
      upcomingReports: '即将发布的报告',
      historicalReports: '历史档案',
      reportDate: '报告日期',
      viewReport: '查看报告',
      downloadPDF: '下载PDF',
    },

    // Institutional Investors Page
    institutional: {
      title: '机构投资者',
      subtitle: '面向家族办公室、对冲基金和财富管理公司的机构级量化策略',
      exclusiveAccess: '独家访问',
      loginRequired: '需要登录。仅限订阅的机构投资者。',
      notSubscribed: '您没有活跃的机构订阅',
      contactUs: '联系我们了解机构订阅信息',
      whatWeOffer: '我们提供什么',
      dueDiligence: {
        title: '完整尽职调查',
        description: '详细的回测报告、压力测试分析和策略文档，供您内部审查',
      },
      customization: {
        title: '定制化',
        description: '根据您的风险配置、投资授权和监管要求调整策略',
      },
      integration: {
        title: 'API集成',
        description: '与您的风险管理系统和执行平台直接集成',
      },
      reporting: {
        title: '专属报告',
        description: '符合您报告标准的定制仪表板和定期报告',
      },
      support: {
        title: '专属支持',
        description: '与量化团队直接联系，解答问题、优化和技术支持',
      },
      compliance: {
        title: '合规支持',
        description: '监管合规和策略审计文档',
      },
      getInTouch: '联系我们',
      getInTouchDesc: '讨论我们的量化策略如何融入您的机构投资组合',
      scheduleCall: '安排通话',
    },

    // Contact Page
    contact: {
      title: '联系方式',
      subtitle: '让我们谈谈您的量化投资',
      getInTouch: '联系我们',
      getInTouchDesc: '对策略有疑问？有兴趣合作？填写表格，我会尽快回复您。',
      name: '姓名',
      email: '邮箱',
      subject: '主题',
      message: '消息',
      send: '发送消息',
      sending: '发送中...',
      successMessage: '消息发送成功！我会尽快回复您。',
      errorMessage: '发送消息时出错。请重试。',
      professionalInquiries: '专业咨询和机构合作',
      followMe: '关注我',
      formTitle: '给我发消息',
      formName: '姓名',
      formEmail: '邮箱',
      formMessage: '消息',
      formSubmit: '发送消息',
      infoTitle: '联系信息',
      emailLabel: '邮箱',
      emailLocked: '在上方发送邮件以解锁',
      linkedinLabel: 'LinkedIn',
      substackLabel: 'Substack',
      fillAll: '请填写所有字段',
      sent: '消息已发送。我会尽快回复。',
      sendError: '发送失败，请重试。',
      connectionError: '连接错误，请稍后再试。',
      methodLabel: '联系方式',
      methodHint: '使用表单给我发消息。我通常在 24–48 小时内回复。',
    },

    // Footer
    footer: {
      rights: '版权所有',
      disclaimer: '过往业绩不保证未来结果。交易涉及风险。',
      privacy: '隐私政策',
      terms: '服务条款',
      legal: '法律声明',
    },

    // Common
    common: {
      present: '至今',
      loading: '加载中...',
      error: '错误',
      success: '成功',
      viewMore: '查看更多',
      learnMore: '更多信息',
      backToTop: '返回顶部',
      downloadBrochure: '下载手册',
    },

    // Terminal Page
    terminal: {
      // General
      quantLab: '量化实验室',
      marketData: '市场数据',
      derivatives: '衍生品',
      signals: '信号',
      research: '研究',
      controls: '控制',
      statistics: '统计',
      numPaths: '路径数量',
      seed: '随机种子',
      showPaths: '显示路径',
      showMean: '显示均值',
      showDistribution: '显示分布',
      showRegimes: '按制度着色',
      terminalMean: '终端均值',
      terminalStd: '终端标准差',
      theoreticalMean: '理论均值',
      theoreticalStd: '理论标准差',
      stationaryMean: '平稳均值',
      stationaryStd: '平稳标准差',
      pricePaths: '价格路径',
      meanReversion: '均值回归过程',
      terminalDistribution: '终端分布',
      priceWithRegimes: '带市场制度的价格路径',
      regimeStats: '制度统计',
      comingSoon: '即将推出',
      footer: '随机过程模拟的教育工具',
      
      // Modules
      macroTerminal: '宏观终端',
      watchlist: '观察列表',
      charts: '图表',
      heatmap: '热力图',
      optionsPricing: '期权定价',
      greeks: '希腊字母计算器',
      volatilitySurface: '波动率曲面',
      liveSignals: '实时信号',
      backtest: '回测引擎',
      economicCalendar: '经济日历',
      newsAnalysis: '新闻分析',

      // GBM
      gbm: {
        name: '几何布朗运动',
        title: '几何布朗运动',
        subtitle: '具有恒定漂移和波动率的股票价格动态经典模型',
      },

      // Ornstein-Uhlenbeck
      ou: {
        name: 'Ornstein-Uhlenbeck',
        title: 'Ornstein-Uhlenbeck过程',
        subtitle: '用于利率、波动率和配对交易的均值回归过程',
      },

      // Regime Switching
      regime: {
        name: '制度转换',
        title: '制度转换模型',
        subtitle: '市场行为在牛市、中性和熊市制度之间变化',
      },

      // Greeks Explorer
      greeksExplorer: {
        name: 'Greeks 探索器',
        title: 'GREEKS · 期权敏感性',
        subtitle: '当输入变化时期权价格如何变化',
        introTitle: '简介',
        introContent: 'Greeks 是 Black-Scholes 公式的偏导数。每个都告诉您期权价格如何响应一个输入的变化。专业交易员不看期权价格——他们看 Greeks。Delta = 0 的投资组合是"delta 中性"——对标的物的小幅波动免疫。Gamma 为正的投资组合是"long convexity"——受益于任何大幅上下波动。理解 Greeks 就是理解期权的实际运作方式。',
        controls: '控制',
        currentGreeks: '当前Greeks',
        callOption: '看涨期权',
        putOption: '看跌期权',
        price: '价格',
        labels: {
          spotPrice: 'S (现货价格)',
          strike: 'K (执行价)',
          timeToExpiry: 'T (到期时间，年)',
          riskFreeRate: 'r (无风险利率)',
          volatility: 'σ (波动率)',
        },
        delta: {
          name: 'Δ (DELTA)',
          title: 'Δ (DELTA) · ∂V/∂S',
          description: 'Delta 是对冲比率。delta 为 0.5 的看涨期权意味着我们卖空 0.5 股来对冲 1 个期权。看涨期权的 Delta 范围从 0 到 1，看跌期权从 -1 到 0。',
          formula: '公式',
          formulaNote: '其中 Φ 是标准正态累积分布函数，d₁ = [ln(S/K) + (r + σ²/2)T] / (σ√T)',
        },
        gamma: {
          name: 'Γ (GAMMA)',
          title: 'Γ (GAMMA) · ∂²V/∂S² = ∂Δ/∂S',
          description: 'Gamma 衡量 delta 变化的速度。高 gamma = delta 随价格小幅波动剧烈翻转。ATM 期权具有最高的 gamma。',
          formula: '公式',
          formulaNote: '其中 φ 是标准正态概率密度函数: φ(x) = (1/√(2π)) exp(-x²/2)',
        },
        vega: {
          name: 'V (VEGA)',
          title: 'V (VEGA) · ∂V/∂σ',
          description: 'Vega 衡量对波动率的敏感性。做多期权 = 做多波动率。如果 σ 上升 1%，期权价格上升 Vega。',
          formula: '公式',
          formulaNote: '看涨和看跌期权的 Vega 相同。显示每 1% 波动率变化。',
        },
        theta: {
          name: 'Θ (THETA)',
          title: 'Θ (THETA) · -∂V/∂t',
          description: 'Theta 是时间衰减。做多期权随时间流逝失去价值（负 theta）。做空期权受益（正 theta）——卖出波动率的基石。',
          formula: '公式',
          formulaNote: '按天显示。对于做多期权，Theta 通常为负（时间衰减）。',
        },
        rho: {
          name: 'ρ (RHO)',
          title: 'ρ (RHO) · ∂V/∂r',
          description: 'Rho 衡量利率敏感性。对于短期期权，rho 很小。对于 LEAPS，它可能很重要。',
          formula: '公式',
          formulaNote: '按无风险利率 1% 变化显示。',
        },
        inStrategies: 'HMA 如何使用',
        fobosStrategy: 'FOBOS 通过期权积极交易波动率。FOBOS 的关键 Greek 是 Vega——当隐含波动率相对于已实现波动率丰富时，FOBOS 卖出期权以获取权利金（负 Vega）。当隐含波动率跌至已实现波动率以下时，FOBOS 通过做多 Gamma 买入凸性。',
        ascalafoStrategy: 'ASCÁLAFO 运行系统性期权策略，其中 Theta 和 Gamma 占主导地位。Theta 是卖出时间的"收益"，但 Gamma 是风险——一次大幅波动会抹去数周的 theta 收集。诀窍是调整头寸大小，使 Theta/Gamma 比率值得承担风险。',
      },

      // Black-Scholes Derivation
      bsDerivation: {
        name: 'Black-Scholes 推导',
        title: 'BLACK-SCHOLES · 从第一性原理',
        subtitle: '诺贝尔奖方程如何实际构建',
        tabs: {
          tab1: '01 · 问题',
          tab2: '02 · 二项式',
          tab3: '03 · 复制',
          tab4: '04 · 连续',
          tab5: '05 · 偏微分方程',
          tab6: '06 · 公式',
        },
        previous: '上一个',
        next: '下一个',
        common: {
          stockPrice: '股票价格',
          strike: 'K',
          strikePrice: '执行价',
          spotPrice: '现货价格',
          timeToExpiry: '到期时间',
          riskFreeRate: '无风险利率',
          volatility: '波动率',
          initialPrice: '初始价格',
          upFactor: '上涨因子',
          downFactor: '下跌因子',
          timeStep: '时间步长',
          numberSteps: '步数',
          years: '年',
        },
        tab1: {
          whatIsOption: '什么是期权？',
          whatIsOptionContent: '欧式看涨期权赋予您在固定日期 T 以固定价格 K 购买资产的权利（非义务）。如果到期时资产价格 S_T 高于 K，您行权并获得 S_T - K。如果低于，您离开时为零。',
          payoffFunction: '支付函数',
          payoffDesc: '到期时，期权价值等于其内在价值：现货与执行价之差，或零。',
          interactivePayoff: '交互式支付图',
          stockPriceAtExpiry: '到期时股票价格',
          payoff: '支付',
          callPayoff: '看涨支付',
          hockeyStick: '曲棍球棒形状：K 以下为零，K 以上为线性。虚线显示执行价。',
          theQuestion: 'Black-Scholes 回答的问题',
          questionText: '我们今天应该为明天获得 max(S_T - K, 0) 的权利支付多少？',
          questionExplanation: '给定 S_T，支付是已知的。问题是我们不知道 S_T。Black-Scholes 向我们展示如何在理想化假设下完全对冲不确定性——从而确定期权的公平价格。',
          assumptions: '假设',
          assumptionsList: [
            '股票遵循几何布朗运动（见 GBM 模块）',
            '恒定波动率 σ',
            '恒定无风险利率 r',
            '无股息、无交易成本、无税收',
            '连续交易、完美流动性',
            '欧式行权（仅在 T，不在之前）',
          ],
        },
        tab2: {simplestUniverse: '最简单的世界', simplestUniverseContent: '一个时间步骤。', binomialTreeParams: '二项树参数', treeValues: '树值', up: '上', down: '下', payoffUp: '支付上', payoffDown: '支付下', wrongApproach: '错误方法', wrongApproachText: '加权平均:', wrongApproachWarning: '这是错误的。市场通过复制定价。'},
        tab3: {centralIdea: '核心思想', centralIdeaContent: '构建股票+现金组合。', replicationPortfolio: '复制组合', replicationDesc: '组合 = Δ 股票 + B 现金', solvingSystem: '求解系统', hedgeRatio: '对冲比率', cash: '现金', optionPrice: '期权价格', riskNeutralProb: '风险中性概率', riskNeutralText1: '简化后:', riskNeutralText2: '其中:', profoundPoint: '关键点:', profoundText: '真实概率 p 从未出现。', riskNeutralQ: 'q:', discountedPrice: '贴现价格:'},
        tab4: {nStepIntro: 'N步树→连续时间', nStepContent: '扩展到N步。', crrParams: 'CRR参数', crrExplanation: '收敛到GBM。', convergenceTitle: '收敛性', convergenceChart: '收敛到BS。', continuousLimit: '连续极限', continuousLimitContent: '变为GBM。'},
        tab5: {derivationIntro: '随机微积分推导', derivationContent: 'GBM:', itosLemma: '伊藤引理', itosContent: '伊藤引理:', hedgePortfolio: '对冲组合', hedgeContent: 'Π = V - Δ·S', noArbitrage: '无套利', noArbitrageContent: '无风险利率:', noArbitrageExplanation: 'PDE:', bsPDE: 'BS偏微分方程', boundaryConditions: '边界条件', boundaryContent: '看涨:', boundaryList: ['V(S,T)=max(S-K,0)', 'V(0,t)=0', 'V→S-K·e^(-r(T-t))'], keyInsight: '关键:', keyInsightContent: '抛物型PDE。'},
        tab6: {closedFormIntro: '闭式解', closedFormContent: '解:', bsFormulaCall: 'BS看涨公式', bsFormulaWhere: '其中:', interactiveCalc: '计算器', callPrice: '看涨价格', putPrice: '看跌价格', priceVsSpot: '价格对现货', bsPrice: 'BS', intrinsicValue: '内在价值', priceChartDesc: 'BS对内在。', impact: '影响', impactContent: '1973年。1997年诺贝尔奖。', greeksNext: 'Greeks: 偏导数。'},
      },
    },
};
